/* global location */
/* global VERSION */

export const GOOGLE_API_KEY = 'AIzaSyABxWy3OohyBaFEVy6ElB_cyKeUTrDVSWg';
const STAGING_HOST_URL = 'demo.ristoranti.it';
const STAGING_HOST_FB_URL = 'https://ristoranti-widget-staging';
const development = {
  name: 'development',
  api_endpoint: 'http://localhost:3000/graphql',
  stripe_key: 'pk_test_N4uv7Nju1n4tKshBiDXhJ0ED',
  fb_app_id: '1907283456216930',
  version: VERSION,
};

const staging = {
  name: 'staging',
  api_endpoint: 'https://api-staging.ristoranti.it/graphql',
  stripe_key: 'pk_test_N4uv7Nju1n4tKshBiDXhJ0ED',
  fb_app_id: '1907297652882177',
  version: VERSION,
};

const production = {
  name: 'production',
  api_endpoint: 'https://api.ristoranti.it/graphql',
  stripe_key: 'pk_live_vLPJilgHuVIIzwIOaAdituAV',
  fb_app_id: '1694667504145194',
  version: VERSION,
};

const ENVS = {
  development,
  production,
};

const isDev = () => process.env.NODE_ENV === 'development';

const getCurrent = () => {
  if (location.href.indexOf(STAGING_HOST_URL) > -1 ||
    location.href.indexOf(STAGING_HOST_FB_URL) > -1
  ) {
    return staging;
  }
  return ENVS[process.env.NODE_ENV];
};

export default {
  getCurrent,
  isDev,
};



// WEBPACK FOOTER //
// ./src/lib/env.js